import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";

import { AuthService, UserPrefSessionService } from "src/app/core/services";

import { DocumentRefService } from "src/app/commons/utils";
import { IAuthUserSession } from "src/app/core/ITypes";
import { UserService } from "src/app/commons/services/user.service";

@Component({
  selector: "sv-role-switcher",
  templateUrl: "./role-switcher.component.html",
  styleUrls: ["./role-switcher.component.scss"],
  providers: [DocumentRefService],
})
export class RoleSwitcherComponent implements OnInit {
  stores = [];
  selectedStore: number;
  loading = false;
  authUser$: Observable<IAuthUserSession>;
  routesException = /(forbidden)/gi;

  constructor(
    private authService: AuthService,
    private router: Router,
    private document: DocumentRefService,
    private userService: UserService,
    private userPrefSession: UserPrefSessionService
  ) {
    this.selectedStore = this.authService.authUser.store.channelId;
    this.populateDropdownOptions();
    this.authUser$ = this.authService.authUser$;
  }

  ngOnInit(): void {}

  async changeRole() {
    try {
      this.loading = true;
      const changedStore = this.authService.assignedStores.find((item) => {
        return item.channelId == this.selectedStore;
      });
      const { token } = await this.authService.createCustomTokenByChannel(
        changedStore.channelId
      );
      this.authService.refreshToken({
        token,
        channelId: changedStore.channelId,
        role: changedStore.role,
      });

      // Save the selected channel ID to user preferences
      await this.saveChannelPreference(changedStore.channelId);

      this.document.getLocation().replace("/dashboard");
    } catch (e) {
      console.error(e);
      this.loading = false;
    }
  }

  populateDropdownOptions() {
    this.stores = this.authService.assignedChannelsOptions;
  }

  private async saveChannelPreference(channelId: number) {
    try {
      if (!this.authService.authUser?.uuid) {
        return;
      }

      // Save to session storage using UserPrefSessionService
      this.userPrefSession.ensureUserMatch(
        this.authService.authUser.uuid,
        channelId
      );

      /* if (!this.authService.authUser.pref) {
        const _userPref = await this.userService.postUserPref({
          last_channel_id: channelId,
          last_preferred_lang: this.localeService.getPreferredLang(),
          user_uuid: this.authService.authUser.uuid,
        });

        this.authService.setUserPref(_userPref);
      } else {
        const updatedPref = {
          ...this.authService.authUser.pref,
          last_channel_id: channelId,
          user_uuid: this.authService.authUser.uuid,
        };

        const result = await this.userService.updateUserPref(
          updatedPref,
          this.authService.authUser.pref.id
        );

        if (result) {
          this.authService.setUserPref(result);
        } else {
          this.authService.setUserPref(updatedPref);
        }
      } */
    } catch (error) {
      console.error("Error saving channel preference:", error);
    }
  }
}
